import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer id="rs-footer" className="bg3 rs-footer">
        {/* Footer Top */}
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-12">
                <div className="about-widget">
                  <img
                    src="assetsfront/images/tlogo.png"
                    style={{
                      width: "30%",
                      background: "white",
                      borderRadius: "197px",
                    }}
                    alt="Footer Logo"
                  />
                  <p>
                    Teaching is conceptual and intellectual, abstract and
                    concrete, creative, and sequential. It’s about people but
                    framed through ideas. It’s about content, hearts, minds, the
                    past, the future–whatever we can imagine, teaching and
                    learning are both causes and effects.
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-12">
                <h5 className="footer-title">OUR LINKS</h5>
                <ul className="sitemap-widget">
                  <li className="active">
                    <Link to="/">
                      <i className="fa fa-angle-right" aria-hidden="true" />
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/topfaculty-about-us">
                      <i className="fa fa-angle-right" aria-hidden="true" />
                      About
                    </Link>
                  </li>
                  <li>
                    <Link to="/myteacherlist">
                      <i className="fa fa-angle-right" aria-hidden="true" />
                      Faculty
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact-us">
                      {" "}
                      <i className="fa fa-angle-right" aria-hidden="true" />
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link to="../our-package-plans">
                      {" "}
                      <i className="fa fa-angle-right" aria-hidden="true" />
                      Our Package
                    </Link>
                  </li>

                     <li>
                    <Link to="../refund-policy">
                      {" "}
                      <i className="fa fa-angle-right" aria-hidden="true" />
                    Refund & Cancellation Policy
                    </Link>
                  </li>
                    <li>
                    <Link to="../privacy-policy">
                      {" "}
                      <i className="fa fa-angle-right" aria-hidden="true" />
                     Privacy Policy
                    </Link>
                  </li>
               

                  <li>
                    <Link to="../terms-conditions">
                      {" "}
                      <i className="fa fa-angle-right" aria-hidden="true" />
                    Terms And Conditions
                    </Link>
                  </li>

                  <li>
                    <Link to="../our-batches">
                      {" "}
                      <i className="fa fa-angle-right" aria-hidden="true" />
                      Icici
                    </Link>
                  </li>
                     <li>
                    <Link to="../daily-update">
                      {" "}
                      <i className="fa fa-angle-right" aria-hidden="true" />
                     Blogs
                    </Link>
                  </li>
                </ul>
                <div className="footer-share">
                  {/* <ul>
                    <li>
                      <Link to="https://www.facebook.com/topfacultyho/?show_switched_toast=0&amp;show_invite_to_follow=0&amp;show_switched_tooltip=0&amp;show_podcast_settings=0&amp;show_community_review_changes=0&amp;show_community_rollback=0&amp;show_follower_visibility_disclosure=0">
                        <i className="fa fa-facebook" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.instagram.com/vedantaias97">
                        <i className="fa fa-instagram" />
                      </Link>
                      </li>
                    <li>
                      <Link to="https://twitter.com/i/flow/login?redirect_after_login=%2FVEDANTA_IAS">
                        <i className="fa fa-twitter" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.linkedin.com/in/vedanta-ias-academy-75b042146/">
                        <i className="fa fa-linkedin" />
                      </Link></li>
                   <li>
                      <Link to="https://www.youtube.com/@vedantaiasacademy7008">
                        <i className="fa fa-youtube" />
                      </Link>
                    </li>
                  </ul> */}
                  <a className="adds" href="tel:9911753333">
                    <img
                      src="assetsfront/images/phon.png"
                      style={{
                        width: "32px",
                        height: "34px",
                      }}
                    />
                  </a>
                  <a className="adds" href="mailto:topfauclty01@gmail.com">
                    <img
                      src="assetsfront/images/email.jpg"
                      style={{
                        width: "32px",
                        height: "34px",
                        borderRadius: "100%",
                      }}
                    />
                  </a>

                  <a
                    className="adds"
                    href="https://www.facebook.com/topfacultyho/?show_switched_toast=0&show_invite_to_follow=0&show_switched_tooltip=0&show_podcast_settings=0&show_community_review_changes=0&show_community_rollback=0&show_follower_visibility_disclosure=0"
                  >
                    <img
                      src="assetsfront/images/facebook.png"
                      style={{
                        width: "32px",
                        height: "34px",
                      }}
                    />
                  </a>
                  <a
                    className="adds"
                    href="https://www.youtube.com/@vedantaiasacademy7008"
                  >
                    <img
                      src="assetsfront/images/youtube.png"
                      style={{
                        width: "32px",
                        height: "34px",
                      }}
                    />
                  </a>
                  <a
                    className="adds"
                    href="https://x.com/i/flow/login?redirect_after_login=%2FVEDANTA_IAS"
                  >
                    <img
                      src="assetsfront/images/tweet.webp"
                      style={{
                        width: "32px",
                        height: "34px",
                        borderRadius: "100%",
                      }}
                    />
                  </a>
                  <a
                    className="adds"
                    href="https://www.instagram.com/vedantaias97/#"
                  >
                    <img
                      src="assetsfront/images/instagram.png"
                      style={{
                        width: "32px",
                        height: "34px",
                      }}
                    />
                  </a>
                  <a
                    className="adds"
                    href="https://www.linkedin.com/in/vedanta-ias-academy-75b042146/"
                  >
                    <img
                      src="assetsfront/images/linkedin.png"
                      style={{
                        width: "32px",
                        height: "34px",
                      }}
                    />
                  </a>
                </div>
              </div>

              <div className="col-lg-5 col-md-12">
                <h5 className="footer-title">Location</h5>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13997.741501061528!2d77.1090191602707!3d28.70653204928338!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d01602040de3b%3A0xef17d4f9c3efb85a!2sVedanta!5e0!3m2!1sen!2sin!4v1690197953325!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
                <p>
                  Address: D-11/156 Sector 8 Rohini, Opp-Pillar No-389, Rohini East Metro Station, Delhi - 110085, India
                </p>
                                <p><a href="mailto:topfauclty01@gmail.com" class="text-blue-600 hover:underline">topfauclty01@gmail.com</a></p>

                <p class="mb-5">
                  <i class=" fa fa-phone"></i> 9911753333, 011-45623300
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
